import axios from "axios";

const authAxios = axios.create({
  baseURL: import.meta.env.VITE_APP_AUTH_URL,
  headers: {
    Accept: "application/json",
  },
});

export default authAxios;
